import { getJson } from '~/support/getJson'

export function getApiV1(path) {
  return getJson(`/api/v1${path}`)
}
